$(() => {
  // To use this alert function, you have to set up an instance variable, @leaving_alert.
  // It should be a Hash including the keys below.
  //
  // {
  //   message: "message",   // A message is shown to a leaving user
  //   selectors: "#back",   // CSS selectors to watch
  // }
  //

  if ($('#leaving-alert-info').length) {
    const $alertInfo = $('#leaving-alert-info');

    const showLeavingAlert = (e: BeforeUnloadEvent) => {
      e = e || window.event;
      // For IE and Firefox prior to version 4
      if (e) {
        e.returnValue = $alertInfo.data('message');
      }
      // For Safari
      return $alertInfo.data('message');
    };

    const attachOnBeforeUnloadHandler = () => {
      window.addEventListener('beforeunload', showLeavingAlert, false);
    };

    // for re-attaching leaving alert from other scripts
    (window as any).attachOnBeforeUnloadHandler = attachOnBeforeUnloadHandler;

    const detachOnBeforeUnloadHandler = () => {
      window.removeEventListener('beforeunload', showLeavingAlert, false);
    };

    // for detaching leaving alert from other scripts
    (window as any).detachOnBeforeUnloadHandler = detachOnBeforeUnloadHandler;

    const initialize = () => {
      // enable submit buttons
      $.each(document.forms, (_, form) => {
        form.addEventListener('submit', detachOnBeforeUnloadHandler, false);
      });

      // additional elements
      const selectors = $alertInfo.data('selectors');
      if (selectors) {
        $.each(selectors, (_, selector) => {
          $.each($(selector), (_, elem) => {
            elem.addEventListener('click', detachOnBeforeUnloadHandler, false);
          });
        });
      }

      attachOnBeforeUnloadHandler();
    };

    initialize();
  }
});
